// WbTicketCentrePane — Phase C10 Group 3.
//
// Composes the weight widget (top) + line-item editor (bottom). Renders
// vertically; the orchestrator drops this into the centre slot of the
// New Ticket page once both groups have shipped.
//
// Sibling Groups 2 (left rail) and 4 (right rail) are referenced only
// through the shared WbTicketContext — this composer doesn't talk to
// them directly.

import { WbTicketCentrePaneLines } from './WbTicketCentrePaneLines';
import { WbTicketCentrePaneWeight } from './WbTicketCentrePaneWeight';
import styles from './WbTicketCentrePane.module.css';

export function WbTicketCentrePane(): JSX.Element {
  return (
    <div className={styles.pane} data-testid="wb-centre-pane">
      <WbTicketCentrePaneWeight />
      <WbTicketCentrePaneLines />
    </div>
  );
}
